import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { getArticles } from "@/lib/api";
import { Reveal } from "@/components/Reveal";

const categories = ["Tous", "Juridique", "Fiscal", "Entrepreneurial"];

export default function Blog() {
  const [articles, setArticles] = useState([]);
  const [categorie, setCategorie] = useState("Tous");
  const [chargement, setChargement] = useState(true);

  useEffect(() => {
    getArticles()
      .then(setArticles)
      .catch(() => {})
      .finally(() => setChargement(false));
  }, []);

  const visibles = articles.filter((a) => categorie === "Tous" || a.categorie === categorie);

  return (
    <>
      <section className="bg-espresso py-28 text-ivory" data-testid="blog-hero">
        <div className="mx-auto max-w-7xl px-6 lg:px-10">
          <Reveal>
            <p className="text-xs font-semibold uppercase tracking-[0.25em] text-gold">Le blogue</p>
            <h1 className="mt-6 max-w-3xl font-serif text-5xl font-medium leading-[1.1] tracking-tight md:text-6xl" data-testid="blog-title">
              Juridique, fiscal, entrepreneurial — en <span className="italic text-primary">langage clair</span>.
            </h1>
            <p className="mt-8 max-w-2xl text-base leading-relaxed text-ivory/70 md:text-lg">
              Nos professionnels et collaborateurs vulgarisent chaque mois les notions qui comptent
              pour les entrepreneurs et les particuliers du Québec.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="bg-background py-20 md:py-28" data-testid="blog-list-section">
        <div className="mx-auto max-w-7xl px-6 lg:px-10">
          <div className="flex flex-wrap gap-3" data-testid="blog-filters">
            {categories.map((c) => (
              <button
                key={c}
                onClick={() => setCategorie(c)}
                data-testid={`blog-filter-${c.toLowerCase()}`}
                className={`rounded-sm border px-5 py-2.5 text-sm font-semibold transition-colors duration-200 ${
                  categorie === c
                    ? "border-primary bg-primary text-primary-foreground"
                    : "border-border bg-background text-foreground/70 hover:border-primary hover:text-primary"
                }`}
              >
                {c}
              </button>
            ))}
          </div>

          {chargement ? (
            <p className="mt-16 text-foreground/50" data-testid="blog-loading">Chargement des articles…</p>
          ) : (
            <div className="mt-14 grid gap-x-10 gap-y-16 md:grid-cols-2 lg:grid-cols-3" data-testid="blog-grid">
              {visibles.map((a, i) => (
                <Reveal key={a.id} delay={(i % 3) * 0.08}>
                  <Link to={`/blogue/${a.slug}`} className="group block border-t-2 border-foreground/80 pt-6" data-testid={`blog-article-${i}`}>
                    <div className="flex items-center justify-between">
                      <span className="text-xs font-semibold uppercase tracking-[0.2em] text-primary">{a.categorie}</span>
                      <ArrowUpRight size={18} className="text-foreground/30 transition-transform duration-200 group-hover:-translate-y-1 group-hover:translate-x-1 group-hover:text-primary" />
                    </div>
                    <h2 className="mt-4 font-serif text-2xl font-semibold leading-snug transition-colors group-hover:text-primary md:text-3xl">
                      {a.titre}
                    </h2>
                    <p className="mt-4 text-sm leading-relaxed text-foreground/60">{a.extrait}</p>
                    <p className="mt-5 text-xs text-foreground/40">{a.date} · {a.lecture} de lecture</p>
                  </Link>
                </Reveal>
              ))}
            </div>
          )}
        </div>
      </section>
    </>
  );
}
